/**
 * NetworkCatchupLink entity class
 */

/**
 * NetworkCatchupLinkFactory
 * returns NetworkCatchupLink entity class
 *
 * @class NetworkCatchupLinkFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkCatchupLink} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkCatchupLinkFactory
 */
/* @ngInject */
export default function NetworkCatchupLinkFactory (NetworkChannelLink) {
  /* === NetworkCatchupLink class === */

  /**
   * NetworkCatchupLink model
   *
   * @class NetworkCatchupLink
   * @classdesc NetworkCatchupLink model
   * @memberof models
   * @see models
   * @extends models.NetworkChannelLink
   * @param {Object} [object] - initial object, containing NetworkCatchupLink entity fields
   * @return {models.NetworkCatchupLink} NetworkCatchupLink entity
   */
  function NetworkCatchupLink () {
    var obj = NetworkChannelLink.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkCatchupLink.prototype = Object.create(NetworkChannelLink.prototype)
  NetworkCatchupLink.prototype.constructor = NetworkCatchupLink

  /* === NetworkCatchupLink instance methods & fields === */

  Object.assign(NetworkCatchupLink.prototype, {

    /**
     * instance fields
     *
     * @memberof models.NetworkCatchupLink#
     * @type {Object}
     */
    _fields: {
      id: Number,
      catchup: 'Catchup',
      network: 'Network',
      sortOrder: Number
    }
  })

  /* === NetworkCatchupLink static methods & fields === */

  // copy all static methods from NetworkChannelLink class
  Object.assign(NetworkCatchupLink, NetworkChannelLink)
  NetworkCatchupLink._name = 'NetworkCatchupLink'
  NetworkCatchupLink.init()

  return NetworkCatchupLink
}
